import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Events, ModalController } from '@ionic/angular';

import { ConfigService } from 'src/app/services/config/config.service';
import { FiltersService } from 'src/app/services/filters/filters.service';
import { LabelService } from 'src/app/services/label/label.service';
import { SharedService } from 'src/app/services/shared/shared.service';
import { UtilsService } from 'src/app/services/utils/utils.service';

@Component({
    selector: 'app-filter',
    templateUrl: './filter.component.html',
    styleUrls: ['./filter.component.scss'],
})
export class FilterComponent implements OnInit {
    customerRate = [4, 3, 2, 1]
    discrate = [10, 20, 30, 40, 50, 60]
    lowerRange: any = 0;
    upperRange: any = 0;
    @Input() categoryId: string;
    @Input() brandId: string;
    parentFilter = [];
    noCategories = false;
    noBrands = false;
    showLoader = true;
    filtersActive = { parent: false, price: false, discount: false, rating: false };
    discountFilter = [
        {
            filter: '10% and above',
            range: [10, 100],
            isChecked: false
        },
        {
            filter: '20% and above',
            range: [20, 100],
            isChecked: false
        },
        {
            filter: '30% and above',
            range: [30, 100],
            isChecked: false
        },
        {
            filter: '40% and above',
            range: [40, 100],
            isChecked: false
        },
        {
            filter: '50% and above',
            range: [50, 100],
            isChecked: false
        },
        {
            filter: '60% and above',
            range: [60, 100],
            isChecked: false
        },
    ];
    ratingFilter = [
        {
            range: [1, 5],
            isChecked: false
        },
        {
            range: [2, 5],
            isChecked: false
        },
        {
            range: [3, 5],
            isChecked: false
        },
        {
            range: [4, 5],
            isChecked: false
        }
    ];
    @Input() discountRange = [0, 100];
    @Input() ratingRange = [0, 5];
    @Input() priceRange = { lower: 1, upper: 2500 };
    priceRangeMin = 1;
    priceRangeMax = 2500;
    priceRangeSteps = 100;
    currencyCode: string;
    @Input() appliedParentFilter: any;
    SHARED_LABELS: any = {};
    @Input() adminFilters: any;
    productRatings = false;
    showdiscButton = false;
    showrateButton = false;
    showbrandButton = false;
    @Output() data_to_sent: any = new EventEmitter();
    @Output() clearAllFilters: any = new EventEmitter();

    constructor(private events: Events,
        private labelService: LabelService,
        private configService: ConfigService,
        private modalController: ModalController,
        private sharedService: SharedService,
        private utilsService: UtilsService,
        private filtersService: FiltersService
    ) {

    }

    ngOnInit() {

        this.currencyCode = this.configService.environment.currencyCode;
        this.productRatings = this.configService.environment.productRatings;
        this.SHARED_LABELS = this.labelService.labels['SHARED'];
        this.initializeSubscriptions();
    }

    ngOnDestroy() {
        this.removeSubscriptions();
    }

    checkbox() {
        console.log("checked")
    }

    _range(event: any) {
        this.lowerRange = event.detail.value.lower;
        this.upperRange = event.detail.value.upper;
    }

    async initializeSubscriptions() {
        if (this.categoryId) {
            this.events.publish('brands:getAllBrandsForUser');
            // console.log(this.events.publish('brands:getAllBrandsForUser')) 
            this.events.subscribe('brands:publishAllBrandsForUser', (brands) => {
                console.log('filter brands', brands)
                this.parentFilter = [];
                brands.forEach(b => {
                    this.parentFilter.push({ id: b.id, name: b.name, isChecked: false });
                });
                if (this.appliedParentFilter && this.appliedParentFilter.hasOwnProperty('ids')) {
                    this.parentFilter.forEach((p) => {
                        if (this.appliedParentFilter.ids.includes(p.id)) {
                            p.isChecked = true;
                        }
                    });
                }
                console.log('this.parentFilter', this.parentFilter);
            });
            this.events.subscribe('brands:noBrandAvailableForUser', () => {
                this.noBrands = true;
                this.showLoader = false;
            });
        }
        if (this.brandId) {
            this.events.publish('product:getAllCategoriesForShop');
            // console.log("executed-bRand")
            this.events.subscribe('product:publishAllCategoriesForShop', (categories) => {
                this.parentFilter = [];
                categories.forEach(c => {
                    this.parentFilter.push({ id: c.id, name: c.name, isChecked: false });
                });
                if (this.appliedParentFilter && this.appliedParentFilter.hasOwnProperty('ids')) {
                    this.parentFilter.forEach((p) => {
                        if (this.appliedParentFilter.ids.includes(p.id)) {
                            p.isChecked = true;
                        }
                    });
                }
                console.log('this.parentFilter', this.parentFilter);

                this.showLoader = false;
            });
            this.events.subscribe('product:noCategoryAvailable', () => {
                this.showLoader = false;
                this.noCategories = true;
            });

        }
        if (this.priceRange.upper === 10000000000000) {
            this.priceRange.upper = this.priceRangeMax;
        }
        if (!this.adminFilters.length) {
            this.adminFilters = [];
            const filters: any = await this.filtersService.getAllActiveFilters();
            if (filters && filters.length) {
                filters.map(f => {
                    f.active = false;
                    let values = [];
                    f.values.map(v => {
                        values.push({ value: v, isChecked: false });
                    });
                    f.values = values;
                });
                this.adminFilters = filters;
                console.log('adminFilters', this.adminFilters);
            }
        }
        console.log(this.categoryId);
        console.log(this.brandId)
    }

    async applyFilters() {
        const uid = await this.sharedService.getStorageUid();
        if (uid && uid !== undefined) {
            let priceRange = { lower: this.priceRange.lower };
            const parentObj = { type: this.categoryId ? 'brands' : 'categories', ids: [] };
            if (this.priceRange.upper === this.priceRangeMax) {
                priceRange['upper'] = 10000000000000;
            } else {
                priceRange['upper'] = this.priceRange.upper;
            }
            for (const d of this.discountFilter) {
                if (d.isChecked) {
                    this.discountRange = d.range;
                    break;
                }
            }
            for (const r of this.ratingFilter) {
                if (r.isChecked) {
                    this.ratingRange = r.range;
                    break;
                }
            }
            for (const p of this.parentFilter) {
                if (p.isChecked) {
                    // if (this.brandId) {
                    //     parentObj.ids.push(p.name)
                    // } else {
                    //     parentObj.ids.push(p.id);
                    // }
                    parentObj.ids.push(p.id);
                }
            }

            this.data_to_sent.emit({
                parentObj: parentObj,
                priceRange: priceRange,
                discountRange: this.discountRange,
                ratingRange: this.ratingRange,
                adminFilters: this.adminFilters,
                clearAll: false
            })
        }
        else {
            this.utilsService.openLoginModal();

        }
    }
    clearAll() {

        this.parentFilter.forEach(pf => {
            pf.isChecked = false

        })
        this.ratingFilter.forEach(rf => {
            rf.isChecked = false

        })
        this.discountFilter.forEach(df => {
            df.isChecked = false
        })

        this.modalController.dismiss({
            clearAll: true
        });

        this.clearAllFilters.emit({
            clearAll: true
        })
    }

    selectFilters(type: string, i: number) {
        if (type === 'parent') {
            this.parentFilter[i].isChecked = !this.parentFilter[i].isChecked;
            if (!this.parentFilter[i].isChecked) {
                this.showbrandButton = false;

            } else {
                this.showbrandButton = true;

            }
        }
    }
    selectRadioFilters(type: string, i: number) {
        if (type === 'discount') {
            for (let index = 0; index < this.discountFilter.length; index++) {
                if (i === index) {
                    this.discountFilter[index].isChecked = !this.discountFilter[index].isChecked;
                    if (!this.discountFilter[index].isChecked) {
                        this.showdiscButton = false;

                    } else {
                        this.showdiscButton = true;

                    }
                }
                else {
                    this.discountFilter[index].isChecked = false;
                }
            }
        }
        if (type === 'rating') {
            for (let index = 0; index < this.ratingFilter.length; index++) {
                if (i === index) {
                    this.ratingFilter[index].isChecked = !this.ratingFilter[index].isChecked;
                    if (!this.ratingFilter[index].isChecked) {
                        this.showrateButton = false;

                    } else {
                        this.showrateButton = true;

                    }

                }
                else {
                    this.ratingFilter[index].isChecked = false;
                }
            }
        }
    }
    selectAdminFilters(i, j) {
        this.adminFilters[i].values[j].isChecked = !this.adminFilters[i].values[j].isChecked;
    }

    disableApplyBtn() {
        let disable = true;
        this.discountFilter.forEach(d => {
            if (d.isChecked) {
                disable = false;
            }
        });
        if (disable) {
            this.ratingFilter.forEach(r => {
                if (r.isChecked) {
                    disable = false;
                }
            });
            if (disable) {
                this.parentFilter.forEach(p => {
                    if (p.isChecked) {
                        disable = false;
                    }
                });
                if (disable) {
                    if (this.priceRange.lower !== 1 || this.priceRange.upper !== this.priceRangeMax) {
                        disable = false;
                    }
                    if (disable) {
                        this.adminFilters && this.adminFilters.forEach(filter => {
                            filter.values.forEach(v => {
                                if (v.isChecked) {
                                    disable = false;
                                }
                            });
                        });
                    }
                }
            }
        }
        return disable;
    }
    hideFilter(filter: any) {
        if (this.categoryId) {
            if (!filter.hasOwnProperty('categories')) {
                return false;
            }
            if (filter.hasOwnProperty('categories') && filter.categories.includes(this.categoryId)) {
                return false;
            } else {
                return true;
            }
        }
        if (this.brandId) {
            if (!filter.hasOwnProperty('brands')) {
                return false;
            }
            if (filter.hasOwnProperty('brands') && filter.brands.includes(this.brandId)) {
                return false;
            } else {
                return true;
            }
        }
    }

    function() {

        console.log(this.brandId)

    }
    removeSubscriptions() {
        this.events.unsubscribe('product:publishAllCategoriesForShop');
        this.events.unsubscribe('product:noCategoryAvailable');
        this.events.unsubscribe('brands:publishAllBrandsForUser');
        this.events.unsubscribe('brands:noBrandAvailableForUser');
        this.events.unsubscribe('filters:publishAllActiveFilters');
    }

}
